import React, { ReactNode } from 'react';
import { Link, useForm } from '@inertiajs/react';
import { Form, Button, Card, Alert } from 'react-bootstrap';
import GuestLayout from '../../Layouts/Guest';

interface Props {
	status?: string;
}

const Login = (props: Props) => {
	const { data, setData, post, processing, errors, reset } = useForm({
		email: '',
		password: '',
		remember: false,
	});

	const submit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		post('/login');
	};

	return (
		<Card className='login-card p-9 rounded-4'>
			<Card.Body>
				{props.status && <Alert className='mb-3'>{props.status}</Alert>}
				<h1 className='h2 fw-bold mb-4 text-center'>
					Login to your account
				</h1>
				<Form onSubmit={submit}>
					<Form.Group controlId='email' className='mb-3'>
						<Form.Label>Email</Form.Label>
						<Form.Control
							type='email'
							value={data.email}
							onChange={(e) => setData('email', e.target.value)}
						/>
						<div className='text-dkRed'>{errors.email}</div>
					</Form.Group>
					<Form.Group controlId='password' className='mb-3'>
						<div className='d-flex align-items-center justify-content-between'>
							<Form.Label>Password</Form.Label>
							<Link href='/forgot-password' className='mb-2'>
								Forgot?
							</Link>
						</div>
						<Form.Control
							type='password'
							value={data.password}
							onChange={(e) =>
								setData('password', e.target.value)
							}
						/>
						<div className='mt-2 text-dkRed'>{errors.password}</div>
					</Form.Group>
					<Button
						variant='secondary'
						type='submit'
						disabled={processing}
						className='mt-3 w-100'
					>
						Sign In
					</Button>
					<p className='text-center mt-5'>
						Don't have an account?
						<br />
						<a href='https://iavaluations.com/contact/' target='_blank'>Contact IA Valuations to get started</a>
					</p>
				</Form>
			</Card.Body>
		</Card>
	);
};

Login.layout = (page: ReactNode) => <GuestLayout>{page}</GuestLayout>;

export default Login;
